<template>
  <b-container class="my-5">
    <b-row>
      <b-col xl="12">
        <b-card no-body>
          <h3 class="card-header bg-white">Contáctenos</h3>
          <b-card-body>
            <p> Si desea comunicarse con nosotros, rellene el siguiente formulario y nos pondremos en contacto con usted a la brevedad posible.</p>
            <b-form @submit="onSubmit">
              <b-form-row>
                <b-form-group
                  class="col-md-6"
                  id="label-name"
                  label="Nombre"
                  label-for="name">
                  <b-input-group>
                    <template v-slot:prepend>
                      <b-input-group-text >
                        <font-awesome-icon :icon="['fas','user']"/>
                      </b-input-group-text>
                    </template>
                    <b-form-input id="name" v-model="form.data.name" placeholder="Nombre" trim required />
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  id="label-email"
                  class="col-md-6"
                  label="Email"
                  label-for="email">
                  <b-input-group prepend="@">
                    <b-form-input type="email" id="email" v-model="form.data.email" placeholder="Correo electrónico" trim required />
                  </b-input-group>
                </b-form-group>
              </b-form-row>
              <b-form-group
                id="label-comments"
                label="Comentarios"
                label-for="comments">
                <b-input-group>
                  <template v-slot:prepend>
                    <b-input-group-text >
                      <font-awesome-icon :icon="['fas','comment']"/>
                    </b-input-group-text>
                  </template>
                  <b-form-textarea id="comments" rows="3" v-model="form.data.comments" placeholder="Escriba sus comentarios" trim required />
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <div id="recaptcha" class="g-recaptcha" :data-sitekey="rcapt_sig_key"></div>
              </b-form-group>
              <b-button type="submit" variant="primary">Enviar</b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col xl="12">
        <adsense
          ad-slot="9585150092"
          ad-format="auto"
          :ad-client="adsenseClient"
          ad-style="display:block">
        </adsense>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Adsense from '@/components/Adsense'

export default {
  components: { Adsense },
  name: 'Contact',
  data () {
    return {
      adsenseClient: process.env.VUE_APP_GOOGLE_ADSENSE_CLIENT,
      rcapt_sig_key: process.env.VUE_APP_RECAPTCHA_API_KEY,
      rcapt_id: '',
      form: {
        data: {
          name: null,
          email: null,
          comments: null
        }
      }
    }
  },
  metaInfo () {
    return {
      titleTemplate: `%s | ${this.$i18n.t('contact_us')}`
    }
  },
  mounted () {
    if (window.grecaptcha) {
      this.rcapt_id = window.grecaptcha.render(
        document.getElementById('recaptcha'),
        { sitekey: process.env.VUE_APP_RECAPTCHA_API_KEY })
    }
  },
  methods: {
    async onSubmit (event) {
      event.preventDefault()
      this.form.data.g_recaptcha_response = window.grecaptcha.getResponse(this.rcapt_id)
      try {
        const response = await this.$http.post('/contact', this.form.data)
        this.$bvToast.toast(response.data.message, {
          title: 'Mensaje enviado',
          variant: 'success',
          autoHideDelay: 5000
        })
        this.onResetForm()
      } catch (error) {
        const err = error.response.data.errors[0]
        this.$bvToast.toast(err.message, {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
      window.grecaptcha.reset()
    },
    onResetForm () {
      this.form.data = { name: '', email: '', comments: '' }
    }
  }
}
</script>
